import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { API_URLS, axiosRequest } from '@lib/axios';
import UserContext from '@lib/contexts/userContext';

/**
 * React Query wrapper for getting the demographics options
 */
const useDemographicOptionsQuery = () => {
  const { authenticated } = useContext(UserContext);

  return useQuery({
    queryKey: ['demo_options'],
    queryFn: async () => axiosRequest({ method: 'GET', url: `${API_URLS.FORMS}/demographics-options`}),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
    select: (options) => {
      // The forms want a separate array for each type of option.
      return {
        age: options.filter(opt => opt.type === 'AGE'),
        gender: options.filter(opt => opt.type === 'GENDER'),
        raceEthnicity: options.filter(opt => opt.type === 'RACE_ETHNICITY'),
      };
    }
  });
};

export default useDemographicOptionsQuery;
